var _path, _line, _line2, _line3, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthdayCakeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8C1.5 6.61929 2.61929 5.5 4 5.5H8C9.38071 5.5 10.5 6.61929 10.5 8V11.5H1.5V8Z",
    stroke: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 11.5,
    x2: 11.5,
    y2: 11.5,
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 5.5,
    x2: 4.5,
    y2: 3.5,
    stroke: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 5.5,
    x2: 7.5,
    y2: 3.5,
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.72727C5 3.08581 4.90894 3.27393 4.82961 3.36525C4.75627 3.44969 4.65181 3.5 4.5 3.5C4.34819 3.5 4.24373 3.44969 4.17039 3.36525C4.09106 3.27393 4 3.08581 4 2.72727C4 2.5932 4.0403 2.40845 4.12441 2.18415C4.2064 1.96552 4.31884 1.73837 4.43638 1.52822C4.45763 1.49024 4.47889 1.45307 4.5 1.41687C4.52111 1.45307 4.54237 1.49024 4.56362 1.52822C4.68116 1.73837 4.7936 1.96552 4.87559 2.18415C4.9597 2.40845 5 2.5932 5 2.72727Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.72727C8 3.08581 7.90894 3.27393 7.82961 3.36525C7.75627 3.44969 7.65181 3.5 7.5 3.5C7.34819 3.5 7.24373 3.44969 7.17039 3.36525C7.09106 3.27393 7 3.08581 7 2.72727C7 2.5932 7.0403 2.40845 7.12441 2.18415C7.2064 1.96552 7.31884 1.73837 7.43638 1.52822C7.45763 1.49024 7.47889 1.45307 7.5 1.41687C7.52111 1.45307 7.54237 1.49024 7.56362 1.52822C7.68116 1.73837 7.7936 1.96552 7.87559 2.18415C7.9597 2.40845 8 2.5932 8 2.72727Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8C4.5 8.82843 3.82843 9.5 3 9.5C2.17157 9.5 1.5 8.82843 1.5 8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8C7.5 8.82843 6.82843 9.5 6 9.5C5.17157 9.5 4.5 8.82843 4.5 8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8C10.5 8.82843 9.82843 9.5 9 9.5C8.17157 9.5 7.5 8.82843 7.5 8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayCakeFilled);
export default __webpack_public_path__ + "static/media/birthday-cake-filled.064617afda34c89357f7023dd644961f.svg";
export { ForwardRef as ReactComponent };